import gql from 'graphql-tag'

export const resourceFragment = gql`
    fragment resourceFragment on Resource{
        id
        name
        description
        tracked
        applyTo
        isUserVehicule
        deleted_at
    }
`
export const staffVehiculeFragment = gql`
    fragment staffVehiculeFragment on StaffVehicule{
        id
        name
        description
        tracked
        applyTo
        isUserVehicule
        userProfile {
            id
            name
        }
    }
`

export const resourceTypeFragment = gql`
    fragment resourceTypeFragment on ResourceType{
        id
        name
        label
        deleted_at
    }
`